import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { intervalToDuration, formatDuration } from 'date-fns';
import { sendScreenEvent } from '@useblu/blu-lytics';

import useGetPaymentLink from '@/services/useGetPaymentLink.service';

const useProcessing = () => {
  const FOUR_MINUTES_IS_MS = 240000;

  const { id } = useParams();
  const navigate = useNavigate();

  const { getLinkIsLoading, getLinkData } = useGetPaymentLink();

  const [showTimer, setShowTimer] = useState<boolean>(true);

  const [timerText, setTimerText] = useState<string | null>(null);

  const getMillisecondsBetweenNowAndIntent = (
    start: Date,
    end: Date,
  ): number => {
    const startInMs = start.getTime();
    const endInMs = end.getTime();

    return Math.abs(startInMs - endInMs);
  };

  const addPadItZero = (num: number) => String(num).padStart(2, '0');

  const convertMillisecondsToHMS = (ms: number): string => {
    const duration = intervalToDuration({ start: 0, end: ms });

    const formatted = formatDuration(duration, {
      format: ['minutes', 'seconds'],
      zero: true,
      delimiter: ':',
      locale: {
        formatDistance: (_token, count) => addPadItZero(count),
      },
    });

    return formatted;
  };

  const setTimeoutText = (timer: number) => {
    const covertedDiff = convertMillisecondsToHMS(timer);
    let timerBackup = timer;

    setTimerText(covertedDiff);

    const interval = setInterval(() => {
      if (timerBackup > 0) {
        timerBackup = timerBackup - 1000;

        const covertedDiff = convertMillisecondsToHMS(timerBackup);
        setTimerText(covertedDiff);
      } else {
        setShowTimer(false);
        setTimerText(null);
        clearInterval(interval);
      }
    }, 1000);
  };

  const setTimeToRetryInMs = (date: Date) => {
    if (date) {
      const diffInMS = getMillisecondsBetweenNowAndIntent(new Date(), date);

      if (diffInMS <= FOUR_MINUTES_IS_MS) {
        setShowTimer(true);
        setTimeoutText(FOUR_MINUTES_IS_MS - diffInMS);
      } else {
        setShowTimer(false);
      }
    }
  };

  const handleOpenLink = () => navigate(`/${id}`);

  useEffect(() => {
    if (getLinkData?.last_payment_link_intent?.created_at) {
      const intentCreatedAt = new Date(
        getLinkData?.last_payment_link_intent?.created_at,
      );

      setTimeToRetryInMs(intentCreatedAt);
    }
  }, [getLinkData]);

  useEffect(() => {
    sendScreenEvent('link_blu_checkout_pending_view');
  }, []);

  return {
    getLinkIsLoading,
    showTimer,
    timerText,
    handleOpenLink,
  };
};

export default useProcessing;
